const ADDRESS_CHAR = `[^\\s<>"',;:()[\\]/]`;
const ADDRESSES_IN_TEXT = new RegExp(
  `${ADDRESS_CHAR}+@${ADDRESS_CHAR}+\\.${ADDRESS_CHAR}+`,
  "g",
);
const WELL_FORMED_ADDRESS = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const ENTRY_SEPARATORS = /[\t\n\r,;]+/;
const WORD_SEPARATORS = /[\s<>"'()[\]/]+/;
const TRAILING_FULL_STOPS = /\.+$/;
const MAX_LOCAL_PART_LENGTH = 64;
const MAX_ADDRESS_LENGTH = 254;

const isDeliverable = (address: string) =>
  WELL_FORMED_ADDRESS.test(address) &&
  address.slice(0, address.lastIndexOf("@")).length <= MAX_LOCAL_PART_LENGTH &&
  address.length <= MAX_ADDRESS_LENGTH;

export interface FoundEmailAddresses {
  addresses: string[];
  unreadable: string[];
}

export const findEmailAddresses = (text: string): FoundEmailAddresses => {
  const addresses = new Set<string>();
  const unreadable: string[] = [];
  text
    .split(ENTRY_SEPARATORS)
    .map((entry) => entry.trim())
    .filter((entry) => entry.length > 0)
    .forEach((entry) => {
      const candidates = [...entry.matchAll(ADDRESSES_IN_TEXT)].map(
        (match) => match[0],
      );
      const deliverable = candidates
        .map((candidate) =>
          candidate.replace(TRAILING_FULL_STOPS, "").toLowerCase(),
        )
        .filter(isDeliverable);
      if (deliverable.length === 0) {
        if (entry.includes("@")) unreadable.push(entry);
        return;
      }
      deliverable.forEach((address) => addresses.add(address));
      unreadable.push(
        ...unreadableAddressLikeWords(entry, candidates, deliverable),
      );
    });
  return { addresses: [...addresses], unreadable };
};

const unreadableAddressLikeWords = (
  entry: string,
  candidates: string[],
  deliverable: string[],
): string[] => {
  const notDelivered = candidates.filter(
    (candidate) =>
      !deliverable.includes(
        candidate.replace(TRAILING_FULL_STOPS, "").toLowerCase(),
      ),
  );
  const rest = candidates.reduce(
    (remaining, candidate) => remaining.replace(candidate, " "),
    entry,
  );
  const strayWords = rest
    .split(WORD_SEPARATORS)
    .filter((word) => word.includes("@"));
  return [...notDelivered, ...strayWords];
};

export const tableAsText = (table: string[][]): string =>
  table.map((row) => row.map((cell) => `${cell ?? ""}`).join("\t")).join("\n");
